<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <!-- Logo & Description -->
        <div class="footer-brand">
          <div class="footer-logo">
            <div class="navbar-logo">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"/>
              </svg>
            </div>
            <span class="footer-brand-name">pruksamarket</span>
          </div>
          <p class="footer-desc">
            ร้านค้าออนไลน์คุณภาพ มุ่งมั่นให้บริการสินค้าที่ดีที่สุด พร้อมการจัดส่งที่รวดเร็วและปลอดภัย
          </p>
        </div>

        <!-- Quick Links -->
        <div class="footer-links">
          <h4 class="footer-title">ลิงก์ด่วน</h4>
          <ul>
            <li><router-link to="/">หน้าแรก</router-link></li>
            <li><router-link to="/products">สินค้าทั้งหมด</router-link></li>
            <li><router-link to="/cart">ตะกร้าสินค้า</router-link></li>
            <li><router-link to="/track">ติดตามคำสั่งซื้อ</router-link></li>
          </ul>
        </div>

        <!-- Contact -->
        <div class="footer-contact">
          <h4 class="footer-title">ติดต่อเรา</h4>
          <div class="contact-item">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
            </svg>
            <a href="https://lin.ee/xC24IDD" target="_blank" rel="noopener noreferrer" class="contact-link">
              LINE: Aura Phruksa
            </a>
          </div>
          <div class="contact-item">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
            </svg>
            <a href="mailto:novagenesis.9999@gmail.com" class="contact-link">
              novagenesis.9999@gmail.com
            </a>
          </div>
        </div>
      </div>

      <!-- Bottom -->
      <div class="footer-bottom">
        <p class="footer-text">© {{ currentYear }} pruksamarket. สงวนลิขสิทธิ์ทุกประการ</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue';

const currentYear = computed(() => new Date().getFullYear());
</script>

<style scoped>
.footer {
  background-color: #1f2937;
  color: #e5e7eb;
  padding: 3rem 1rem 1.5rem;
  margin-top: 4rem;
}

.footer-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
}

@media (min-width: 768px) {
  .footer-content {
    grid-template-columns: 2fr 1fr 1fr;
  }
}

.footer-brand {
  max-width: 300px;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.footer-logo .navbar-logo {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #f59e0b, #d97706);
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.footer-brand-name {
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
}

.footer-desc {
  font-size: 0.875rem;
  color: #9ca3af;
  line-height: 1.6;
}

.footer-title {
  font-size: 1rem;
  font-weight: 600;
  color: white;
  margin-bottom: 1rem;
}

.footer-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 0.5rem;
}

.footer-links a {
  color: #9ca3af;
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.2s ease;
}

.footer-links a:hover {
  color: #f59e0b;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
  color: #9ca3af;
}

.contact-item svg {
  color: #f59e0b;
  flex-shrink: 0;
}

.contact-link {
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.2s ease;
  word-break: break-all;
}

.contact-link:hover {
  color: #f59e0b;
}

.footer-bottom {
  border-top: 1px solid #374151;
  padding-top: 1.5rem;
  text-align: center;
}

.footer-text {
  font-size: 0.875rem;
  color: #6b7280;
}
</style>
